import React, { ReactNode } from "react";

interface Props {
    children: ReactNode
}

export const Page: React.FC<Props> = (props: Props) => {
    return (
      <div style={{overflow: "auto", maxHeight: "calc(100vh - 60px)"}}>
        <div className="tw-w-11/12 tw-content-center tw-items-center tw-my-4 tw-mx-auto">
          {props.children}
        </div>
      </div>
    );
  }